import React from 'react'

type DropdownClosingFunction = () => void

/* Close all dropdowns per level, just start a new provider on the body to avoid closing the parent dropdown */
export class DropdownOrchestrationStore {
  // Keep this uninitialized, making the instantiation as cheap as possible
  registeredDropdowns?: Set<DropdownClosingFunction>
  registerClosingFn(handlingFunction: DropdownClosingFunction) {
    if (!this.registeredDropdowns) this.registeredDropdowns = new Set<DropdownClosingFunction>()
    this.registeredDropdowns.add(handlingFunction)
  }
  unregisterClosingFn(handlingFunction: DropdownClosingFunction) {
    this.registeredDropdowns?.delete(handlingFunction)
  }
  handleOpen(handlingFunction: DropdownClosingFunction) {
    for (const closingFunction of this.registeredDropdowns ?? []) {
      if (closingFunction === handlingFunction) continue
      closingFunction()
    }
  }
}

export const DropdownOrchestrationContext = React.createContext<DropdownOrchestrationStore | null>(null)
